import { CSS } from '@grupoboticario/flora-react';

import { IconButtonShare } from './BaseShareIcon.styles';

type TBaseShareIcon = {
  ariaLabel: string;
  dataTestId?: string;
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
  css?: CSS;
  tabIndex?: number;
};
export const BaseShareIcon = (props: TBaseShareIcon) => (
  <IconButtonShare
    as="a"
    target="_blank"
    aria-label={props.ariaLabel}
    data-test-id={props.dataTestId}
    {...props}
  >
    {props.children}
  </IconButtonShare>
);
